import React from "react";
import SagarPhoto from "../assets/Sagar.jpg";

export default function Home() {
  return (
    <section className="section hero hero-centered">
      <div className="hero-centered-media" aria-label="Sagar portrait">
        <img src={SagarPhoto} alt="Sagar" className="hero-centered-photo" />
      </div>
      <div className="hero-centered-copy">
        <h1>Hey, I'm <span className="accent">Sagar</span><span style={{paddingLeft: "10px"}}/> <span className="hero-centered-copy-text">
          I'm a software engineer focused on building products users love. I try my best to create things with <span className="heart" role="img" aria-label="love">❤</span>
          Connect with me on <a href="https://www.linkedin.com/in/sagaras/" target="_blank" rel="noopener noreferrer" className="social-link linkedin">
            <svg className="social-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="currentColor" d="M19 3A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H19M8.34 17.34V10.66H5.67V17.34H8.34M7 9.5A1.33 1.33 0 1 0 7 6.84 1.33 1.33 0 0 0 7 9.5M18.33 17.34V13.6C18.33 11.36 17.14 10.33 15.5 10.33A3.17 3.17 0 0 0 13.33 11.5H13.27V10.66H10.73V17.34H13.4V13.93C13.4 12.93 13.6 12 14.8 12 16 12 16.06 13 16.06 14V17.34Z"/>
            </svg>
            LinkedIn
          </a>.
        </span></h1>
        
      </div>
    </section>
  );
}


